import $axios from '@/axios-instance.js'

export class ContentLibraryElementsService {
  baseUrl = '/api/v1/admin/content-libraries'
  child = 'elements'
  static make() {
    return new ContentLibraryElementsService()
  }
  // Create
  store(uuid, params) {
    return $axios.post(`${this.baseUrl}/${uuid}/${this.child}`, params)
  }

  storeBulk(uuid, elements) {
    return $axios.post(`${this.baseUrl}/${uuid}/${this.child}/bulk`, {
      elements,
    })
  }

  // Read all - findAll
  index(uuid, params) {
    return $axios.get(`${this.baseUrl}/${uuid}/${this.child}`, params)
  }

  // Read one - show
  show(uuid, id, params) {
    return $axios.get(`${this.baseUrl}/${uuid}/${this.child}/${id}`, params)
  }

  // Update
  update(uuid, id, payload) {
    return $axios.post(`${this.baseUrl}/${uuid}/${this.child}/${id}`, {
      ...payload,
      _method: 'PUT',
    })
  }

  // Delete - delete
  destroy(uuid, id, params) {
    return $axios.delete(this.baseUrl + `/${id}`, params)
  }
}
